import { get, isEmpty } from 'lodash';

export const NAME_SEPARATORS = ['-', "'", ' '];

export const getCapitalizedString = (obj, fields = [], separators = [], defaultValue = '') => {
  if (isEmpty(obj) || !fields.length) {
    return defaultValue;
  }

  return fields
    .map((field) => {
      let fieldValue = (get(obj, field, '') || '').trim();

      separators.forEach((separator) => {
        fieldValue = fieldValue
          .split(separator)
          .map((chunk) => {
            const [firstLetter] = chunk;

            return !firstLetter ? chunk : `${firstLetter.toUpperCase()}${chunk.substring(1)}`.trim();
          })
          .join(separator);
      });

      return fieldValue;
    })
    .join(' ')
    .trim();
};

export const getUserFullName = (userData, defaultValue = '') =>
  getCapitalizedString(userData, ['first_name', 'last_name'], NAME_SEPARATORS, defaultValue) || defaultValue;
